import React from 'react';
import { useUserAssetsStore } from '../../hooks/useUserAssetsStore';

const BlockAmount = ({ block }) => {
  const { userAssets } = useUserAssetsStore();
  const blockFromAssets = userAssets.find((asset) => asset['asset-id'] === block.index);
  const amount = blockFromAssets ? blockFromAssets.amount : 0;
  return <span>{amount}</span>;
};

export default BlockAmount;
